module.exports = __webpack_public_path__ + "img/bg-2.6e4dbde6.jpg";